import type React from 'react'
import type { ChartRow } from './ChartRow.ts'
import { StackedBarChartNext } from './StackedBarChartNext.tsx'
import type { StackSeries } from './StackSeries.ts'

interface LineChartPlotProps {
  data: ChartRow[]
  stackSeries: StackSeries[]
  onBarClick?: (key: string) => void
  ylabel: string
  xlabel: string
  xTickMaxChars?: number
  xTickRotate?: number
  height?: number | `${number}%`
  hideCaption?: boolean
  /** Samples per bucket, aligned to `data` by index; shown in the tooltip. */
  sampleCounts?: (number | undefined)[]
}

/**
 * Overlaid (non-stacked) line chart. Thin delegate over the shared echarts `StackedBarChartNext`
 * (`variant="line"`, which overlays rather than stacks).
 */
export const LineChartPlot: React.FC<LineChartPlotProps> = ({
  data,
  xTickRotate,
  xTickMaxChars,
  stackSeries,
  onBarClick,
  ylabel,
  xlabel,
  height,
  hideCaption,
  sampleCounts
}) => (
  <>
    {hideCaption !== true && <h2 className="text-2xl font-semibold mb-6 text-gray-800">LineChart</h2>}
    <StackedBarChartNext
      variant="line"
      dataKey="xAxisvalue"
      data={data}
      sampleCounts={sampleCounts}
      stackSeries={stackSeries}
      ylabel={ylabel}
      xlabel={xlabel}
      onBarClick={onBarClick}
      xTickMaxChars={xTickMaxChars}
      xTickRotate={xTickRotate}
      height={height}
    />
  </>
)
